const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;

const getSasToken = async (
  propertyId: number,
  token: string,
  blob: Blob,
  filename: string,
) => {
  const response = await fetch(`${apiBaseUrl}/properties/${propertyId}/media`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      fileName: filename,
      contentType: blob.type,
      fileSize: blob.size,
    }),
  });

  return await response.json();
};

const uploadBlobViaSas = async (
  uploadUrl: string,
  blob: Blob,
  onProgress: ((progress: number) => void) | undefined,
) => {
  await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.open('PUT', uploadUrl);
    xhr.setRequestHeader('x-ms-blob-type', `BlockBlob`);
    xhr.setRequestHeader('Content-Type', blob.type);
    xhr.setRequestHeader('x-ms-blob-content-type', blob.type);

    if (onProgress) {
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          const progress = Math.round((event.loaded / event.total) * 100);
          onProgress(progress);
        }
      };
    }

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(
          new Response(xhr.response, {
            status: xhr.status,
            statusText: xhr.statusText,
          }),
        );
      } else {
        reject(new Error(`Upload failed with status: ${xhr.status}`));
      }
    };

    xhr.onerror = (err) => {
      console.error(err);
      reject(new Error(`Network error occurred during upload: ${err}`));
    };

    xhr.send(blob);
  });
};

export const uploadPropertyMedia = async (
  propertyId: number,
  blob: Blob,
  filename: string,
  token: string,
  onProgress?: (progress: number) => void,
) => {
  // Step 1: Get SAS token from your API
  const { uploadUrl } = await getSasToken(propertyId, token, blob, filename);

  // Step 2: Upload directly to Azure Blob Storage using the SAS URL
  await uploadBlobViaSas(uploadUrl, blob, onProgress);
};
